import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useParams, useLocation, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { UserService } from '../../../support/services/api';
import { logOut } from '../../../support/store/AuthReducer';

import './styles.css';

function PasswordRetrieval() {
  const [password, setPassword] = useState();
  const [confirmation, setConfirmation] = useState();

  const { token } = useParams();
  const userId = (new URLSearchParams(useLocation().search)).get('userId');

  const submit = async (e) => {
    e.preventDefault();

    if (!password || password.length < 6) return toast('A senha deve ter, no mínimo, 6 dígitos', { type: toast.TYPE.WARNING });
    if (password !== confirmation) return toast('Ops! Você digitou uma confirmação diferente da senha', { type: toast.TYPE.WARNING });

    return UserService().updatePassword({ token, userId, password })
      .then(() => {
        toast('Senha alterada com sucesso', { type: toast.TYPE.SUCCESS });
      });
  };

  useEffect(() => logOut(), []);

  return (
    <div className="container">
      <section className="top-bar">
        <h2>Recuperação de senha</h2>
        <div className="divisory">
          <div className="divisory-line" />
        </div>
      </section>

      <div className="inputs-container">
        <div className="floating-label-input">
          <input placeholder="Senha" id="password" type="password" name="password" value={password || ''} onChange={(e) => setPassword(e.target.value)} />
          <label htmlFor="password">Senha</label>
        </div>

        <div className="floating-label-input">
          <input placeholder="Confirmação" id="confirmation" type="password" name="confirmation" value={confirmation || ''} onChange={(e) => setConfirmation(e.target.value)} />
          <label htmlFor="confirmation">Confirmação</label>
        </div>

        <button type="submit" className="submit-button" onClick={(e) => submit(e)}>
          Alterar senha
        </button>
      </div>
    </div>
  );
}

PasswordRetrieval.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withRouter(PasswordRetrieval);
